import { Box } from '@mui/material';
import { Message } from '@schooly/api';
import { getListItemBorderSx } from '@schooly/style';
import React from 'react';

import { ListViewMessagesRow } from '../ListViewMessagesRow/ListViewMessagesRow';

export interface ListViewMessagesProps {
  messages: Message[];
  groupId?: string;
  isProfileView?: boolean;
}

export const ListViewMessages: React.FC<ListViewMessagesProps> = ({
  messages,
  groupId,
  isProfileView,
}) => {
  return (
    <Box>
      {messages.map((message, index) => (
        <ListViewMessagesRow
          key={message.id}
          message={message}
          groupId={groupId}
          isProfileView={!!isProfileView}
          sx={{
            ...getListItemBorderSx({ index, total: messages.length }),
            '.MuiCardActionArea-root': { height: isProfileView ? 44 : 36, paddingRight: 0 },
          }}
        />
      ))}
    </Box>
  );
};
